// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "1.5rem";
var _4 = "#dedede";
var _5 = "#adf";
var _6 = "1rem";
var _7 = "#bebebe";
var _8 = ".8rem";
var _9 = "#000";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "extraLargeFontSize", _4 as "lightGrey", _5 as "lightblue", _6 as "mediumFontSize", _7 as "mediumLightGrey", _8 as "smallFontSize", _9 as "unusedNodeColor" }
